import React, { HTMLAttributes, useRef, useState } from "react";
import { sendUserFeedback } from "../../../apis/parkingbeesRelatedService";
import { customShowToast } from "../../../helper/toast";
import BaseButton from "../../atoms/baseButton";

interface IContactUsForm {}

type TContactUsFormProps = IContactUsForm & HTMLAttributes<HTMLFormElement>;

const ContactUsForm: React.FC<TContactUsFormProps> = (props) => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const formRef = useRef<HTMLFormElement>(null);

  const sendFeedbackToClient = async (
    name: string,
    email: string,
    phone: string,
    message: string
  ) => {
    try {
      const emailResponse = await sendUserFeedback(name, email, phone, message);

      if (emailResponse.statusCode === 202) {
        customShowToast("我們已收到您的寶貴意見!", "success");
        setName("");
        setEmail("");
        setPhone("");
        setMessage("");
      } else {
        customShowToast("發送失敗，請稍後再試!");
      }
    } catch (error) {
      console.log(error);
      customShowToast("發送失敗，請稍後再試!");
    }
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    // Submit the form programmatically
    if (formRef.current) {
      sendFeedbackToClient(name, email, phone, message);

      formRef.current.reset();
    }
  };

  return (
    <form
      ref={formRef}
      className="flex flex-col gap-5 rounded-3xl p-5 bg-mainDark text-lightDark"
    >
      <div className="flex flex-col gap-5 justify-between items-center">
        <div className="flex w-full flex-row items-center gap-5">
          <div className="flex flex-col text-sm min-w-20">
            <span>名稱*</span>
            <span>Name</span>
          </div>
          <input
            type="text"
            className="flex flex-1 w-full bg-transparent border border-[#666666] rounded-xl p-3"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        <div className="w-full flex flex-row items-center gap-5">
          <div className="flex flex-col text-sm min-w-20">
            <span>聯絡電話*</span>
            <span>Phone No.</span>
          </div>
          <input
            type="phone"
            className="flex flex-1 w-full bg-transparent border border-[#666666] rounded-xl p-3"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
        </div>

        <div className="w-full flex flex-row items-center gap-5">
          <div className="flex flex-col text-sm min-w-20">
            <span>電郵*</span>
            <span>E-mail</span>
          </div>
          <input
            type="email"
            className="flex flex-1 w-full bg-transparent border border-[#666666] rounded-xl p-3"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
      </div>

      <div className="flex w-full flex-col gap-3">
        <div className="flex flex-col text-sm min-w-20">
          <span>內容／查詢*</span>
          <span>Content/Inquiry</span>
        </div>
        <textarea
          className="h-40 bg-transparent border border-[#666666] rounded-xl p-3 resize-none"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        ></textarea>
      </div>

      <BaseButton
        type="submit"
        disabled={!email || !phone || !name || !message}
        className="w-full laptop:w-[14.75rem] ml-auto"
        onClick={handleClick}
      >
        <div className="flex flex-col text-white">
          <span>送出</span>
          <span>Send</span>
        </div>
      </BaseButton>
    </form>
  );
};

export default ContactUsForm;
